module.exports = __webpack_public_path__ + "static/img/open-title-1-new.7764e1a6.png";